import axios from 'axios';
/* const config = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
} */
export default {
    login:(data)=>{
        return axios.post('user/login', data);
    },
    register:(data)=>{
        return axios.post('user/signup', data);
    },
    userMe:()=>{
        return axios.get('auth/me');
    },
    recoverPassword:(data)=>{
        return axios.post('password/email', data);
    },
    resetPassword:(data)=>{
        return axios.post('password/recover', data);
    },
    validateTokenRecaptcha:(data)=>{
        return axios.post('check/recaptcha', data);
    },
    verifyEmail:(token)=>{
        return axios.get('verificar_correo/'+token);
    },
    resendEmail:()=>{
        return axios.get('reenvio/correo/verificaion');
    },
    countries: () => {
        return axios.get('countries');
    }
}
